import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import { QadderLogo } from './Logo';
import { useLanguage } from './LanguageContext';

const SUBJECTS = [
  { id: 'الكل',     icon: '📚', color: '#7c6df8', label: 'الكل',    section: null },
  { id: 'رياضيات', icon: '📐', color: '#3b82f6', label: 'رياضيات', section: '18ef5d52-dade-449f-89bb-6fc94fab3520' },
  { id: 'فيزياء',  icon: '⚡', color: '#f59e0b', label: 'فيزياء',  section: '11111111-1111-1111-1111-111111111101' },
  { id: 'كيمياء',  icon: '⚗️', color: '#10b981', label: 'كيمياء',  section: '11111111-1111-1111-1111-111111111102' },
  { id: 'أحياء',   icon: '🧬', color: '#ec4899', label: 'أحياء',   section: '11111111-1111-1111-1111-111111111103' },
];

export default function SubjectScreen({ onSelect, onBack }) {
  const { t, isRTL } = useLanguage();
  const [counts, setCounts] = useState({});

  useEffect(() => {
    const load = async () => {
      const c = {};
      for (const s of SUBJECTS) {
        if (s.id === 'الكل') continue;
        let q = supabase.from('questions').select('count', { count: 'exact', head: true })
          .eq('subject', s.id);
        const { count } = await q;
        c[s.id] = count || 0;
      }
      // الكل = مجموع الكل
      c['الكل'] = Object.values(c).reduce((a, b) => a + b, 0);
      setCounts(c);
    };
    load();
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg-page)',
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      padding: '32px 20px', fontFamily: 'Tajawal,sans-serif', direction: isRTL ? 'rtl' : 'ltr',
    }}>
      <div style={{ width: '100%', maxWidth: 440 }}>

        {/* هيدر */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
          <QadderLogo onHome={onBack} size={32} />
          <button onClick={onBack} style={{
            background: 'var(--bg-card)', border: '1px solid var(--border)',
            borderRadius: 10, padding: '7px 14px', color: 'var(--text-secondary)',
            fontSize: 13, cursor: 'pointer',
            display: 'flex', alignItems: 'center', gap: 6,
          }}>{t('subject_back')}</button>
        </div>

        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 48, marginBottom: 10 }}>🎓</div>
          <h2 style={{ color: 'var(--text)', fontSize: 24, fontWeight: 900, margin: '0 0 8px' }}>
            {t('subject_title')}
          </h2>
          <p style={{ color: 'var(--text-secondary)', fontSize: 14, margin: 0 }}>
            {t('subject_subtitle')}
          </p>
        </div>

        {/* بطاقات المواد */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          {SUBJECTS.map(s => (
            <button
              key={s.id}
              onClick={() => onSelect({ subject: s.id, section: s.section })}
              style={{
                background: `${s.color}12`,
                border: `2px solid ${s.color}40`,
                borderRadius: 20, padding: '22px 16px',
                cursor: 'pointer', textAlign: 'center',
                fontFamily: 'Tajawal,sans-serif',
                transition: 'all 0.2s',
                gridColumn: s.id === 'الكل' ? 'span 2' : 'span 1',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.background = `${s.color}25`;
                e.currentTarget.style.borderColor = `${s.color}80`;
                e.currentTarget.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = `${s.color}12`;
                e.currentTarget.style.borderColor = `${s.color}40`;
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div style={{ fontSize: 36, marginBottom: 8 }}>{s.icon}</div>
              <div style={{ color: 'var(--text)', fontWeight: 800, fontSize: 17, marginBottom: 4 }}>
                {s.label}
              </div>
              <div style={{
                color: s.color, fontSize: 12, fontWeight: 700,
                background: `${s.color}20`, borderRadius: 20,
                padding: '3px 10px', display: 'inline-block', marginTop: 4,
              }}>
                {counts[s.id] !== undefined ? `${counts[s.id].toLocaleString()} ${t('subject_questions')}` : '...'}
              </div>
            </button>
          ))}
        </div>

      </div>
    </div>
  );
}
